<template>
  <div class="app-header">
    <div class="header-toolbar app-center">
      <div class="toolbar-section">
        <router-link to="/">
          <img alt="Logo" src="../../assets/logos/logo.png" class="logo" />
        </router-link>
      </div>
      <div class="toolbar-section">
        <p class="welcome-message">WELCOME</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppHeader",
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
div.app-header {
  padding: 24px 0;

  div.header-toolbar {
    div.toolbar-section {
      display: inline-block;

      img.logo {
        width: 200px;
      }

      p.welcome-message {
        color: #fa9f1b;
        font-weight: 400;
        font-size: 18px;
      }
    }
  }
}
</style>
